import { TemplateContentType } from "features/Influencer/ContactList/schema";

export enum TemplateCreatePage {
  method = "method",
  import = "import",
  questions = "questions",
  bentoAi = "bento-ai",
  edit = "edit",
}

export interface FormAnswer {
  templateContentType?: TemplateContentType;
  niche?: string;
  existingBaseTemplateId?: number; // template to base on
}
